/* Dynamic PWA manifest generator + install prompt detection.
   Each role gets its OWN web-app identity (id) so the browser treats them as
   separate installable PWAs. The user can install Cashier, Waiter and Driver
   apps on the same device side-by-side with their own icons & names. */

const ICON_URL =
    "https://customer-assets.emergentagent.com/job_cafe24-pos/artifacts/1jnt118o_BCO.bbb59530-38f7-4180-a822-7f1415f69e2c.png";

// Define one persona per role. Keep `id` stable per role so re-installs
// detect existing installations correctly.
const PERSONAS = {
    customer: {
        id: "/menu?app=customer",
        name: "كافيه 24",
        short_name: "كافيه 24",
        start_url: "/menu",
        scope: "/menu",
    },
    owner: {
        id: "/?app=owner",
        name: "كافيه 24 — مالك",
        short_name: "كافيه 24 — مالك",
        start_url: "/login",
        scope: "/",
    },
    manager: {
        id: "/?app=manager",
        name: "كافيه 24 — مدير",
        short_name: "كافيه 24 — مدير",
        start_url: "/staff-login",
        scope: "/",
    },
    cashier: {
        id: "/?app=cashier",
        name: "كافيه 24 — كاشير",
        short_name: "كافيه 24 — كاشير",
        start_url: "/staff-login",
        scope: "/",
    },
    waiter: {
        id: "/?app=waiter",
        name: "كافيه 24 — ويتر",
        short_name: "كافيه 24 — ويتر",
        start_url: "/staff-login",
        scope: "/",
    },
    kitchen: {
        id: "/?app=kitchen",
        name: "كافيه 24 — مطبخ",
        short_name: "كافيه 24 — مطبخ",
        start_url: "/staff-login",
        scope: "/",
    },
    driver: {
        id: "/?app=driver",
        name: "كافيه 24 — سائق",
        short_name: "كافيه 24 — سائق",
        start_url: "/staff-login",
        scope: "/",
    },
};

/** Map current URL to its persona key */
export function detectPersona() {
    const path = window.location.pathname;
    const stored = (() => {
        try {
            const raw = localStorage.getItem("cafe24_token");
            if (!raw) return null;
            const payload = JSON.parse(atob(raw.split(".")[1] || ""));
            return payload.role || null;
        } catch {
            return null;
        }
    })();

    if (path.startsWith("/menu")) return "customer";
    if (path.startsWith("/dashboard") || path === "/login") return stored === "manager" ? "manager" : "owner";
    if (path.startsWith("/cashier")) return "cashier";
    if (path.startsWith("/waiter")) return "waiter";
    if (path.startsWith("/kitchen")) return "kitchen";
    if (path.startsWith("/driver")) return "driver";
    if (path.startsWith("/staff-login") && stored && PERSONAS[stored]) return stored;
    return "customer"; // safe default for root visitors
}

/** Build the manifest object for a persona */
function buildManifest(persona) {
    return {
        ...persona,
        icons: [
            { src: ICON_URL, sizes: "192x192 512x512", type: "image/png", purpose: "any" },
            { src: ICON_URL, sizes: "192x192 512x512", type: "image/png", purpose: "maskable" },
        ],
        display: "standalone",
        theme_color: "#120a05",
        background_color: "#120a05",
        orientation: "any",
        lang: "ar",
        dir: "rtl",
    };
}

let lastBlobUrl = null;

/** Replace the document's <link rel="manifest"> with a per-persona blob URL. */
export function applyDynamicManifest(personaKey) {
    const persona = PERSONAS[personaKey] || PERSONAS.customer;
    const manifest = buildManifest(persona);
    const blob = new Blob([JSON.stringify(manifest)], { type: "application/manifest+json" });
    const url = URL.createObjectURL(blob);

    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
        link = document.createElement("link");
        link.rel = "manifest";
        document.head.appendChild(link);
    }
    link.href = url;

    // Also update tab title & apple-touch shortcut name for nicer feel
    document.title = persona.name;
    let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!appleTitle) {
        appleTitle = document.createElement("meta");
        appleTitle.name = "apple-mobile-web-app-title";
        document.head.appendChild(appleTitle);
    }
    appleTitle.content = persona.short_name;

    if (lastBlobUrl) URL.revokeObjectURL(lastBlobUrl);
    lastBlobUrl = url;
    return persona;
}

export const PERSONA_LIST = PERSONAS;
